import { motion } from "framer-motion";
import styles from "./Home.module.css";
import { Link } from "react-router-dom";

// Visitors who ask for less motion get the still poster instead of the looping video
const reduceMotion =
  typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const Home = () => {
  return (
    <div className={styles.wrapper}>
      <video
        className={styles.video}
        autoPlay={!reduceMotion}
        muted
        loop
        playsInline
        preload="metadata"
        poster="/hero-poster.jpg"
        aria-hidden="true"
      >
        <source src="/hero.mp4" type="video/mp4" />
      </video>
      <motion.div
        className={styles.hero}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <h1 className={styles.name}>MyApple</h1>
        <p className={styles.tagline}>
          Web, Marketing and Data Development
        </p>
        <p className={styles.sub}>
          Empowering businesses to harness data
          and maximize profitability through tailored analysis and technology.
        </p>
        <Link to="/services" className={styles.cta}>Explore Our Services →</Link>
      </motion.div>
    </div>
  );
};

export default Home;